import * as Yup from 'yup';

const country = Yup.string().when('isRm', {
  is: true,
  then: Yup.string().required('Country is required'),
});

export default country;
